module.exports = __webpack_public_path__ + "img/chevron_right.9483ff96.svg";